import styled from 'styled-components';

export const Place = styled.div`
  margin: 0 0 10px;
`;

export const StyledLabel = styled.label`
  margin-right: 0.5rem;
`;
